import { fork, take, call, put, race } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import ReactOnRails from 'react-on-rails'

import { initSocialNetworks, socialSharePost, addNotification, showShareDialog, doShare, showPreloader } from '../actions'
import { postDealGiftsCallback } from '../services/api'
import FacebookAPI from '../services/social/fb'
import VkontakteAPI from '../services/social/vk'
import { loginFb, loginVk, wallShareSignalVK } from '../services/api'

export function* raceWithTimeout(saga, props, timeout = 60000) {
  const { success, failure } = yield race({
    success: call(saga, props),
    failure: delay(timeout)
  })

  if (failure) throw Error('Время оижадния отклика превышено. Попробуйте ещё раз.')
  else return success
}

export default function* socialShare () {
  yield take(initSocialNetworks)
  const fb = new FacebookAPI({ appId: '359143420847165' }) // dev for localhost: 664541237072094
  const vk = new VkontakteAPI({ apiId:  2913841 }) // dev for localhost: 6617050

  while (true) {
    const { payload: { message, link, provider, dealId, dealGiftId, redirectUrl } } = yield take(socialSharePost)
    const isProviderVK = provider === 'vkontakte'
    const client = isProviderVK ? vk : fb
    const loginOnServer = isProviderVK ? loginVk : loginFb

    try {
      yield put(showPreloader(true))
      const token = ReactOnRails.authenticityToken()
      const sessionToken = yield raceWithTimeout(client.login)
      const resp = yield call(loginOnServer, sessionToken, window.location)

      if (!resp.auth_token) throw Error(resp.error || 'Не удалось авторизоваться на сервере КупиКупона')
      
      if (isProviderVK) {
        yield call(wallShareSignalVK, { dealId, dealGiftId })
        yield put(showShareDialog(true))
        yield take(doShare)
        yield put(showShareDialog(false))
      }
      
      const postId = yield raceWithTimeout(client.wallPost, { message, link })
      yield call(postDealGiftsCallback, { postId, dealId, dealGiftId, provider, token })

      window.location = redirectUrl
    } catch (err) {
      yield put(addNotification({
        message: err ? (err.error_msg || err.message || err) : 'Unknown error',
        level: 'error',
        autoDismiss: 0,
        dismissible: 'both'
      }))
      yield fork(socialShare)
      yield put(showPreloader(false))
    }
  }
}



// WEBPACK FOOTER //
// app/javascript/src/sagas/socialShare.js